module.exports = __webpack_public_path__ + "img/preview.d951f84d.png";